<template>
    <application-layout>
        <v-container style="width: 75vw">
            <v-main class="pa-0">
                <v-layout>
                    <h1>Agent Disposition Call List</h1>
                </v-layout>
                <v-card>
                    <v-layout  class="px-3 mt-3">
                        <v-flex xs4>
                            <h3 class="mt-3 mb-2">Select an Agent</h3>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex class="px-3 mb-4">
                            <v-card class="py-2 px-3">
                                <v-select
                                    data-testid="call-list-agent-menu"
                                    class="call-list-agent-menu"
                                    v-model="selectedAgent"
                                    :items="agentsList"
                                    :item-text="item => `${item.last_name}, ${item.first_name}`"
                                    item-value="id"
                                    placeholder="Select an Agent"
                                />
                            </v-card>
                        </v-flex>
                        <v-flex xs4 class="px-3 my-4">
                            <v-btn
                                data-testid="call-list-get-agent-btn"
                                class="call-list-get-agent-btn"
                                color="primary"
                                block
                                :disabled="!selectedAgent"
                                @click="getSelectedAgentsDispositions"
                            >
                                Submit
                            </v-btn>
                        </v-flex>
                        <v-flex xs4 class="px-3 my-4">
                            <v-btn
                                data-testid="call-list-reset-agent-btn"
                                class="call-list-reset-agent-btn"
                                color="error"
                                block
                                :disabled="!selectedAgent"
                                @click="resetDataTable"
                            >
                                Reset
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="selectedAgent" class="pb-3">
                        <v-flex class="px-3 mt-1" xs4>
                            <h3 class="mb-2">Start Date</h3>
                            <v-card class="pa-3">
                                <v-layout>
                                    <v-flex xs10>
                                        <v-menu
                                            data-testid="call-list-start-date-menu"
                                            class="call-list-start-date-menu"
                                            ref="menu"
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="selectedStartDate"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    data-testid="call-list-disposition-start-date-input"
                                                    class="call-list-disposition-start-date-input"
                                                    v-model="selectedStartDate"
                                                    label="Select Start Date"
                                                    prepend-icon="event"
                                                    readonly
                                                    v-on="on"
                                                />
                                            </template>
                                            <v-date-picker
                                                data-testid="call-list-start-date-date-picker"
                                                class="call-list-start-date-date-picker"
                                                v-model="selectedStartDate"
                                                :min="minDate"
                                                :max="currentDate"
                                                no-title
                                                scrollable
                                            >
                                                <v-spacer />
                                                <v-btn
                                                    data-testid="cancel-disposition-start-date-btn"
                                                    class="cancel-disposition-start-date-btn"
                                                    text
                                                    color="primary"
                                                    @click="menu = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    data-testid="submit-disposition-start-date-btn"
                                                    class="submit-disposition-start-date-btn"
                                                    text
                                                    color="primary"
                                                    @click="$refs.menu.save(selectedStartDate)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                        <v-flex class="px-3 my-1" xs4>
                            <h3 class="mb-2">End Date</h3>
                            <v-card class="pa-3">
                                <v-layout>
                                    <v-flex xs10>
                                        <v-menu
                                            data-testid="call-list-end-date-menu"
                                            class="call-list-end-date-menu"
                                            ref="menu2"
                                            v-model="menu2"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="selectedEndDate"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    data-testid="call-list-disposition-end-date-input"
                                                    class="call-list-disposition-end-date-input"
                                                    v-model="selectedEndDate"
                                                    label="Select End Date"
                                                    prepend-icon="event"
                                                    readonly
                                                    v-on="on"
                                                />
                                            </template>
                                            <v-date-picker
                                                data-testid="call-list-end-date-date-picker"
                                                class="call-list-end-date-date-picker"
                                                v-model="selectedEndDate"
                                                :min="minDate"
                                                :max="currentDate"
                                                no-title
                                                scrollable
                                            >
                                                <v-spacer />
                                                <v-btn
                                                    data-testid="cancel-disposition-end-date-btn"
                                                    class="cancel-disposition-end-date-btn"
                                                    text
                                                    color="primary"
                                                    @click="menu2 = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    data-testid="submit-disposition-end-date-btn"
                                                    class="submit-disposition-end-date-btn"
                                                    text
                                                    color="primary"
                                                    @click="$refs.menu2.save(selectedEndDate)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                        <v-flex class="px-3 my-1" xs4>
                            <h3 class="mb-2">Disposition Type</h3>
                            <v-card class="pa-3">
                                <v-layout >
                                    <v-flex xs10>
                                        <v-select
                                            data-testid="call-list-disposition-type-menu"
                                            class="call-list-disposition-type-menu px-3"
                                            v-model="selectedDispositionId"
                                            :items="allDispositionTypes"
                                            item-text="dispositionName"
                                            item-value="dispositionId"
                                            label="Disposition Type"
                                        />
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                    <v-alert
                      v-if="weHaveAProblem && displayTable"
                      class="ma-4"
                      dense
                      outlined
                      type="error"
                    >
                      One or more items in this page have invalid call type(s) or disposition(s)
                    </v-alert>
                    <v-data-table
                        v-if="displayTable"
                        :headers="headers"
                        :items="dispositionList"
                        :server-items-length="dispositionCount"
                        :options.sync="pagination"
                        :loading="loading"
                        no-data-text="No results found."
                        :footer-props="{'items-per-page-options': [5, 10, 25, 50]}"
                        class="elevation-1 mt-2"
                        fixed-header
                        height="50vh"
                    >
                      <template slot="item" slot-scope="props">
                        <tr>
                          <td>{{ props.item.user.first_name }} {{ props.item.user.last_name }}</td>
                          <td>{{ props.item.location_code }}</td>
                          <!-- call type -->
                          <td v-if="getCallType(props.item)">
                            {{ getCallType(props.item) }}
                          </td>
                          <null-data-table-cell v-else />

                          <td>{{ formatDate(props.item.created_at) }}</td>

                          <!-- disposition name -->
                          <td v-if="getDispositionName(props.item)">
                            {{ getDispositionName(props.item) }}
                          </td>
                          <null-data-table-cell v-else />

                          <td>{{ props.item.contact_phone }}</td>
                          <td class="py-3">
                              <v-btn
                                  data-testid="change-disposition-btn"
                                  class="change-disposition-btn"
                                  small
                                  color="primary"
                                  @click="editDisposition(props.item)"
                              >
                                  Change Disposition
                              </v-btn>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                </v-card>
            </v-main>

            <update-disposition
                v-model="updateModal"
                :callTypes="callTypes"
                :dispositionTypes="dispositionTypes"
                :updateObj="updateObj"
                @updateDispositionAndCall="updateDispositionAndCall($event)"
            />

        </v-container>
    </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout";
import NullDataTableCell from "./partials/NullDataTableCell";
import UpdateDisposition from "./UpdateDisposition";
import { callListHeaders } from "@/helpers/call-list/call-list-data-table-headers";
import moment from "moment";

export default {
  data() {
    return {
      headers: callListHeaders,
      callTypes: [],
      dispositionTypes: [],
      loading: false,
      pagination: {
        itemsPerPage: 25,
        sortDesc: [false]
      },
      isUpdated: false,

      selectedDispositionId: null,
      selectedAgent: null,
      currentDate: new Date().toISOString().substr(0, 10),
      selectedStartDate: new Date().toISOString().substr(0, 10),
      selectedEndDate: new Date().toISOString().substr(0, 10),

      menu: false,
      menu2: false,
      landscape: false,
      reactive: false,

      updateModal: false,
      updateObj: null,
      newDispositionValue: null
    };
  },

  methods: {
    getCallType(item) {
      if (!item || !item.disposition || !item.disposition.call_type) {
        return null;
      }
      return item.disposition.call_type.name;
    },

    getDispositionName(item) {
      if (!item || !item.disposition) {
        return null;
      }
      return item.disposition.name;
    },

    editDisposition(item) {
      this.updateModal = true;
      this.updateObj = item;
    },

    getSelectedAgentsDispositions() {
      this.loading = true;
      this.isUpdated = true;
      let params = {
        start_date: this.selectedStartDate,
        end_date: this.selectedEndDate,
        agent_id: this.selectedAgent,
        disposition_id: this.selectedDispositionId,
        page: this.pagination.page,
        per_page: this.pagination.itemsPerPage,
        order_direction: this.pagination.sortDesc[0] ? "DESC" : "ASC"
      };

      if (this.pagination.sortBy) {
        params.order_by = this.pagination.sortBy[0];
      }

      this.$store.dispatch("retrieveSelectedAgentDispositions", params)
        .then(() => {
          this.loading = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    },

    getDispositionsList() {
      this.loading = true;
      this.$store.dispatch("getAllDispositions")
        .then(resp => {
          this.dispositionTypes = resp.data.dispositions;
          this.loading = false;
        });
    },

    getCallTypes() {
      this.$store.dispatch("getAllCallTypes")
        .then(resp => {
          this.callTypes = resp.data.call_types;
        });
    },

    resetDataTable() {
      this.$store.dispatch("clearSelectedAgentDispositions");
      this.selectedDispositionId = null;
      this.selectedAgent = null;
      this.selectedStartDate = this.currentDate;
      this.selectedEndDate = this.currentDate;
      this.isUpdated = false;
    },

    updateDispositionAndCall(newDisposition) {
      this.loading = true;

      this.updateObj.disposition_id = newDisposition;

      let params = {
        id: this.updateObj.id,
        disposition_id: newDisposition.id
      };

      this.$store.dispatch("updateDispositionAndCallType", params)
        .then(() => {
          this.loading = false;
          this.updateModal = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    formatDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },

    // Keep just in case, but had to remove because some of these phone #s make no sense whatsoever
    formatPhone(phone) {
      const slicedPhone = phone.slice(2);
      return slicedPhone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    }
  },

  computed: {

    weHaveAProblem() {
      if (!this.dispositionList) {
        return false;
      }
      return this.dispositionList.findIndex((item) => (
        !item.disposition ||
        !item.disposition.call_type
      )) > -1;
    },

    dispositionCount() {
      return this.agentDisposition ? this.agentDisposition.total : 0;
    },

    agentDisposition() {
      return this.$store.state.callList.dispositionsData.calls;
    },

    dispositionList() {
      return this.agentDisposition ? this.agentDisposition.data : [];
    },

    agentsList() {
      return this.$store.getters.agents;
    },

    allDispositionTypes() {
      return this.dispositionTypes.map(disposition => {
        return { dispositionName: disposition.name, dispositionId: disposition.id };
      });
    },

    minDate() {
      return moment().month(0).date(1).year(2016).format("YYYY-MM-DD");
    },

    displayTable() {
      if (this.selectedAgent && this.isUpdated && this.dispositionList) {
        return true;
      } else {
        return false;
      }
    }
  },

  // ===== Watchers ===== //
  watch: {
    pagination: {
      handler() {
        this.getSelectedAgentsDispositions();
      },
      deep: true
    }
  },

  components: {
    ApplicationLayout,
    NullDataTableCell,
    UpdateDisposition
  },

  created() {
    this.getDispositionsList();
    this.getCallTypes();
  }
};
</script>
